import React from 'react';
import { Switch, Route } from "react-router-dom";
import { pathnames } from 'lib/routes';
import BusinessInfoForm from './business-info';
import Representatives from './representatives';
import Owners from './owners';
import Docs from './docs';

const BusinessInfo = () => {
  return (
    <Switch>
      <Route path={pathnames.business_info} exact>
        <BusinessInfoForm />
      </Route>
      <Route path={pathnames.business_representatives}>
        <Representatives />
      </Route>
      <Route path={pathnames.business_owners}>
        <Owners />
      </Route>
      <Route path={pathnames.business_docs}>
        <Docs />
      </Route>
    </Switch>
  )
};

export default BusinessInfo;
